<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create Carrier Master Data</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Update Master Data</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave">


          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Tag Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Tag Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.parentTagId')">
            <label>ScaCode</label>
            <md-input v-model="dataForm.scacode"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>


          <calling-api type="bar" path="/api/w/masterData/update">

            <md-dialog-actions>
              <md-button class="md-primary" @click="showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required, } from 'vuelidate/lib/validators';

  const getInitialDataForm = () => ({
    group: null,
    tagId: null,
    tagName: null,
    parentGroup: null,
    parentTagId: null,
    active: true,
  });

 const getCarrierDataForm = () => ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    scacode: null,
  });

  export default {
    mixins: [validationMixin],
    props: {
      mode: String,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      stores: [],
      dispatchers: [],
      dataForm: getCarrierDataForm(),
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
      ]),
      getDispatcherInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`;
      },
      getSpecialStatusInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.statusName} (${this.dataForm.statusId})`;
      },
    },
    watch: {},
    validations: {
      dataForm: {
        group: {
          required,
        },
        tagId: {
          required,
        },
        tagName: {
          required,
        },
      },
    },
    methods: {
      openDialog(existingData) {
        this.dataForm = getCarrierDataForm();
        this.$v.dataForm.$reset();

        console.log(`openDialog`, existingData);
        if (existingData && this.mode === 'update') {
          this.dataForm.group = existingData.group;
          this.dataForm.tagId = existingData.tagId;
          this.dataForm.tagName = existingData.tagName;
          this.dataForm.active = existingData.active;
          this.dataForm.scacode = existingData.scacode;
        }

        this.showDialog = true;
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      doSave() {
        this.$v.dataForm.$touch();

        if (this.$v.dataForm.$invalid) {
          return;
        }

        this.$store
          .dispatch(
            "updateMasterData",
            this.dataForm,
          )
          .then(() => {
            this.showDialog = false;
            this.onUpdate();
          });
      },
    },
  };
</script>
